<script>
    import { page } from '$app/stores';
    import { t } from '$lib/i18n.js';
</script>

<div class="links">
    <ul>
        <li class="inactive">{$t('components.footer.links_section.learn_more')}</li>
        <li>
            <a href="#"
               on:click|preventDefault={() => (window.location.href = `/${$page.params.lang}/driver`)}
               aria-label={$t('components.footer.links_section.how_it_works')}>
            {$t('components.footer.links_section.how_it_works')}
            </a>
        </li>
        <li>
            <a href="#"
               on:click|preventDefault={() => (window.location.href = `/${$page.params.lang}/owner`)}
               aria-label={$t('components.footer.links_section.publish_your_car')}>
            {$t('components.footer.links_section.publish_your_car')}
            </a>
        </li>
        <li><a href="https://auting.notion.site" aria-label={$t('components.footer.links_section.faq')}>{$t('components.footer.links_section.faq')}</a></li>
        <li><a href="https://blog.auting.it" aria-label={$t('components.footer.links_section.blog')}>{$t('components.footer.links_section.blog')}</a></li>
    </ul>
    <ul>
        <li class="inactive">{$t('components.footer.links_section.product')}</li>
        <li><a href="https://itunes.apple.com/it/app/auting/id1447229186" aria-label={$t('components.footer.links_section.download_ios')}>{$t('components.footer.links_section.download_ios')}</a></li>
        <li>
            <a href="https://play.google.com/store/apps/details?id=it.auting.auting" aria-label={$t('components.footer.links_section.download_android')}>{$t('components.footer.links_section.download_android')}</a>
        </li>
    </ul>
    <ul>
        <li class="inactive">{$t('components.footer.links_section.legal')}</li>
        <li><a href="/assicurazione" data-sveltekit-reload aria-label={$t('components.footer.links_section.limitations')}>{$t('components.footer.links_section.limitations')}</a></li>
        <li><a href="/{$page.params.lang}/privacy-policy" aria-label={$t('components.footer.links_section.privacy_policy')}>{$t('components.footer.links_section.privacy_policy')}</a></li>
        <li><a href="https://scopri.auting.it/condizioniUtilizzo/" aria-label={$t('components.footer.links_section.terms_of_service')}>{$t('components.footer.links_section.terms_of_service')}</a></li>
        <li><a href="/{$page.params.lang}/cookie-policy" aria-label={$t('components.footer.links_section.cookie_policy')}>{$t('components.footer.links_section.cookie_policy')}</a></li>
    </ul>
    <ul>
        <li class="inactive">{$t('components.footer.links_section.partner')}</li>
        <li><img src="https://auting.it/assets/images/5f3c4b29.logo-reale-mutua.png" alt="Reale Mutua Logo" /></li>
    </ul>
</div>

<style>
    .links {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: flex-start;
        margin-top: 32px;
        width: 100%;
    }

    .links ul {
        flex: 1;
        width: 100%;
        list-style: none;
    }

    .links ul li {
        margin-bottom: 12px;
    }

    .links ul li.inactive {
        color: var(--surface-50);
        font-size: 18px;
        line-height: 140%;
        font-weight: 400;
    }

    .links ul li a {
        color: var(--surface);
        font-size: 18px;
        line-height: 140%;
        font-weight: 400;
        letter-spacing: -4%;
    }

    @media (max-width: 768px) {
        .links {
            flex-direction: column;
            align-items: center;
            justify-content: center;
        }

        .links ul {
            padding-bottom: 40px;
        }

        .links ul li {
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .links ul li.inactive {
            text-align: center;
        }

        .links ul li a {
            text-align: center;
        }
    }
</style>
